<template>
  <div class="channels-action-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="400px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="params" label-width="80px">
        <el-form-item label="频道名称:" prop>
          <el-input size="small" placeholder="请输入频道名称" v-model="params.name"></el-input>
        </el-form-item>
        <el-form-item label="频道排序:" prop>
          <el-input size="small" placeholder="请输入频道排序" v-model="params.name"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="submitForm('form')" :loading="flag">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: "",
      dialogVisible: false,
      flag: false,
      params: {
        name: "",
      },
    };
  },
  methods: {
    // 关闭弹窗时
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        name: "",
      };
    },
    // eslint-disable-next-line no-unused-vars
    open(type, data) {
      this.dialogVisible = true;
      if (type === "edit") {
        this.title = "编辑频道";
      } else {
        this.title = "新增频道";
      }
    },
  },
};
</script>